import { api } from "../../utils/api";

export const getPublicMapLink = async (data) => {
  const response = await api.get(`map-link-public/${data.empId}/${data.typeMap}`);
  return response.data;
};